import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout from "../../../components/Layout/Layout";
import DiscountHubService from "../../../services/DiscountHubService";
import { HollowDotsSpinner } from "react-epic-spinners";
import { ArrowLeftIcon } from "@heroicons/react/outline";
import fire from "../../../utils/Toastr";

export default function CreateStaffReferralCode() {
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState({
    name: "",
    emailAddress: "",
    referralCode: "",
    misCode: "",
    accountNumber: "",
    customerNumber: "",
    bvn: "",
    nin: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = { ...formValues };
      if (!payload.customerNumber) {
        delete payload.customerNumber;
      }
      const resp = await DiscountHubService.createStaffReferralCode(payload);
      if (resp && resp.status !== false) {
        fire("success", resp.message || "Staff referral code created successfully");
        navigate("/discount-hub/staff-referral-codes");
      } else {
        fire("error", resp?.message || "Failed to create exempted staff referral code");
      }
    } catch (error) {
      console.error("Error creating exempted staff referral code:", error);
      fire("error", "Failed to create exempted staff referral code");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout title="Create Exempted Staff Referral Code" pageTag="discount-hub" current="/discount-hub/staff-referral-codes">
      <React.Fragment>
        <main>
          <div className="max-w-4xl mx-auto">
            <div className="mb-6">
              <Link
                to="/discount-hub/staff-referral-codes"
                className="inline-flex items-center text-sm text-red-600 hover:text-red-500"
              >
                <ArrowLeftIcon className="h-4 w-4 mr-1" />
                Back to Exempted Staff Referral Codes
              </Link>
            </div>

            <div className="bg-white shadow rounded-lg">
              <div className="px-6 py-4 border-b border-gray-200">
                <h2 className="text-lg font-medium text-gray-900">
                  Create Exempted Staff Referral Code
                </h2>
              </div>
              <form onSubmit={handleSubmit} className="px-6 py-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Name
                    </label>
                    <input
                      type="text"
                      name="name"
                      required
                      value={formValues.name}
                      onChange={handleChange}
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-red-500 focus:border-red-500 sm:text-sm"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Email Address
                    </label>
                    <input
                      type="email"
                      name="emailAddress"
                      required
                      value={formValues.emailAddress}
                      onChange={handleChange}
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-red-500 focus:border-red-500 sm:text-sm"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Referral Code
                    </label>
                    <input
                      type="text"
                      name="referralCode"
                      required
                      value={formValues.referralCode}
                      onChange={handleChange}
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-red-500 focus:border-red-500 sm:text-sm"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      MIS Code
                    </label>
                    <input
                      type="text"
                      name="misCode"
                      required
                      value={formValues.misCode}
                      onChange={handleChange}
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-red-500 focus:border-red-500 sm:text-sm"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Account Number
                    </label>
                    <input
                      type="text"
                      name="accountNumber"
                      required
                      value={formValues.accountNumber}
                      onChange={handleChange}
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-red-500 focus:border-red-500 sm:text-sm"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Customer Number
                    </label>
                    <input
                      type="text"
                      name="customerNumber"
                      value={formValues.customerNumber}
                      onChange={handleChange}
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-red-500 focus:border-red-500 sm:text-sm"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      BVN
                    </label>
                    <input
                      type="text"
                      name="bvn"
                      required
                      value={formValues.bvn}
                      onChange={handleChange}
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-red-500 focus:border-red-500 sm:text-sm"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      NIN
                    </label>
                    <input
                      type="text"
                      name="nin"
                      required
                      value={formValues.nin}
                      onChange={handleChange}
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-red-500 focus:border-red-500 sm:text-sm"
                    />
                  </div>
                </div>

                <div className="flex justify-end space-x-3 pt-6">
                  <Link
                    to="/discount-hub/staff-referral-codes"
                    className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  >
                    Cancel
                  </Link>
                  <button
                    type="submit"
                    disabled={loading}
                    className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:opacity-60"
                  >
                    {loading ? (
                      <HollowDotsSpinner size={12} color="#FFFFFF" className="mr-2" />
                    ) : null}
                    {loading ? "Creating..." : "Create Exempted Staff Referral Code"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </main>
      </React.Fragment>
    </Layout>
  );
}
